import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { StorageService } from '../service/storage.service';
import { UuidService } from '../service/uuid.service';
import { environment } from 'src/environments/environment';
import { LoaderService } from '../service/loader.service';
import { LanguageService } from '../service/language.service';
import { ClientContextService } from '../service/client-context.service';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private readonly returnAllLangPaths = [
    '/dp/product-details/',
    '/dp/vendor-category-list/',
  ];

  userData: any;

  constructor(
    public storageService: StorageService,
    public loader: LoaderService,
    public uuidService: UuidService,
    private languageService: LanguageService,
    private clientContextService: ClientContextService
  ) {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    this.loader.setLoading(true);
    this.userData = this.getAuthDataSync();
    const isApiUrl = this.isApiRequest(request.url);
    
    let headers = request.headers;
    
    if (isApiUrl) {
      headers = headers.set('device_id', this.uuidService.getUuid());
      const clientHeaders = this.clientContextService.getApiHeaders();
      Object.entries(clientHeaders).forEach(([key, value]) => {
        headers = headers.set(key, value);
      });
    }

    if (isApiUrl) {
      if (this.usesReturnAllLang(request.url)) {
        headers = headers.set('X-Return-Lang', 'all');
      } else {
        const lang = this.languageService.current === 'ar' ? 'ar' : 'en';
        headers = headers.set('lang', lang);
      }
    }

    if (this.userData?.token && isApiUrl && !request.url.includes('/v2/refresh-token')) {
      headers = headers.set('Authorization', `Bearer ${this.userData.token}`);
    }
    
    request = request.clone({ headers });
    
    return next.handle(request).pipe(
      map((evt: HttpEvent<any>) => {
        if(evt instanceof HttpResponse){
          this.loader.setLoading(false);
        }
        return evt;
      })
    );
  }

  private getAuthDataSync(): any | null {
    try {
      const raw = localStorage.getItem('authData');
      return raw ? JSON.parse(raw) : null;
    } catch {
      return null;
    }
  }

  private usesReturnAllLang(url: string): boolean {
    return this.returnAllLangPaths.some((path) => url.includes(path));
  }

  private isApiRequest(url: string): boolean {
    const base = environment.apiBaseUrl.replace(/\/$/, '');
    if (url.startsWith(base)) {
      return true;
    }
    if (!base.startsWith('/')) {
      return false;
    }
    try {
      const parsed = new URL(url, window.location.origin);
      return parsed.pathname === base || parsed.pathname.startsWith(`${base}/`);
    } catch {
      return false;
    }
  }
}
